module.exports = __webpack_public_path__ + "img/male.82da8567.png";